/**
 * Placement-test intro screen.
 */
import React from "react";
import { useTranslation } from 'react-i18next';

import { VButton } from "form";

/**
 * Explains the placement test and starts the attempt.
 *
 * @param {{ onContinue?: Function }} props
 */
const PositionFirst = (props) => {

  const { totalCount, onContinueClick } = props;

  const { t } = useTranslation('common');

  return <>
    <div className="w-full">
      <div className="fsp-20 mt-3">{totalCount}&nbsp;{t('questions')}</div>
      <div className="flex items-center flex-col shadow mt-5 p-4">
        <img className="size-70" src="https://files.plateformedoctonet.com/app-eduforma/Challenge.png" alt="" />
        <p className="fsp-18 text-muted">
          {t("It's time to test your knowledge before starting your training! **")}
        </p>
        <p className="fsp-18 text-muted">
          {t('This quiz will allow you to know your initial level so that you can set goals.')}
        </p>
        <VButton onClick={onContinueClick} variant="contained">
          {t('Start the quiz')}
        </VButton>
      </div>
      <ul className="mt-4">
        <li>{t("You cannot repeat this quiz more than once when it comes to your placement test. If necessary, it allows our teaching team to reposition you on the level corresponding to your needs.")}</li>
        <li>{t("At the end of this test and in the absence of repositioning, you will be able to start module 1 of your training.")}</li>
      </ul>
    </div>
  </>
}

export default PositionFirst;